// READ MORE

$('.read-more a').click(function(){
    if ($(this).text() == 'Read More') {
      $(this).text('Read Less');
    }
    else {
      $(this).text('Read More');
    }
    
    $('.coll-desc').toggleClass('active');
});

// FILTER DROPDOWN

$(function() {
  $('.filter-option').click(function(e){
    $(this).addClass('active').siblings().removeClass('active');
    e.stopPropagation()
  });
  $(document).click(function(e){
    if ($(e.target).is(".filter-option") === false) {
      $(".filter-option").removeClass("active");
    }
  });
});

// REMOVE STICKY HEADER 

if( (window.location.href.indexOf('collections') > -1) || (window.location.href.indexOf('search') > -1) ) {
  $('.sticky-header-container .stick').removeClass('stick');
  }

// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.coll-filter').outerHeight();

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();
  	var colHeight = $("#coll-filter").height();
    
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('.coll-filter').removeClass('stick-filter').fadeOut;
      	$('.filter-coll').css('height', 'auto');
    } else {
      // Scroll Up
      if(st >= 368) {
        if(st + $(window).height() < $(document).height()) {
          $('.coll-filter').addClass('stick-filter');
          $('.filter-coll').css('height', colHeight);
        }
      }
      else {
        $('.coll-filter').removeClass('stick-filter');
        $('.filter-coll').css('height', 'auto');
      }
    }
    
    lastScrollTop = st;
  
}


  
  //   ACTIVE NAV
  
  if(window.location.href.indexOf("women") > -1){
    $('.nav-item:nth-child(1) > .nav-link').addClass('active')
  }
  else if(window.location.href.indexOf("lingerie") > -1){
    $('.nav-item:nth-child(2) > .nav-link').addClass('active')
  }
  else if(window.location.href.indexOf("men") > -1){
    $('.nav-item:nth-child(3) > .nav-link').addClass('active')
  }
  else if(window.location.href.indexOf("kids") > -1){
    $('.nav-item:nth-child(4) > .nav-link').addClass('active')
  }
  else if(window.location.href.indexOf("food") > -1){
    $('.nav-item:nth-child(5) > .nav-link').addClass('active')
  }
  else if(window.location.href.indexOf("beauty") > -1){
    $('.nav-item:nth-child(6) > .nav-link').addClass('active')
  }
  else if(window.location.href.indexOf("offers") > -1){
    $('.nav-no-mega > .nav-link').addClass('active')
  }
  


  // document.addEventListener("DOMContentLoaded", function() {
  //   var endlessScroll = new Ajaxinate({
  //     container: '#AjaxinateContainers',
  //     pagination: '#AjaxinatePaginations',
  //     method: 'scroll',
  //     offset: 0,
  //     loadingText: ''
  //   });
  // });
  
  // function Scrolldown() {
  //  window.scroll(0,100); 
  // }
  
  // window.onload = Scrolldown;
  
  // setTimeout(function(){ 
  //   $('.coll-main').show();
  // }, 5000);